// src/components/player.tsx
import { useCallback as useCallback9, useEffect as useEffect7, useMemo as useMemo3, useRef as useRef7, useState as useState6 } from "react";
import { clsx as clsx5 } from "clsx";

// src/assets/play.svg
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var SvgPlay = (props) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 31", ...props, children: /* @__PURE__ */ jsx("path", { d: "M15.552 15.168q0.448 0.32 0.448 0.832 0 0.448-0.448 0.768l-13.696 8.512q-0.768 0.512-1.312 0.192t-0.544-1.28v-16.448q0-0.96 0.544-1.28t1.312 0.192z" }) });

// src/assets/pause.svg
import * as React2 from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var SvgPause = (props) => /* @__PURE__ */ jsx2("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 32", ...props, children: /* @__PURE__ */ jsx2("path", { d: "M14.080 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048zM2.88 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048z" }) });

// src/assets/right.svg
import * as React3 from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var SvgRight = (props) => /* @__PURE__ */ jsx3("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props, children: /* @__PURE__ */ jsx3("path", { d: "M22 16l-10.105-10.6-1.895 1.987 8.211 8.613-8.211 8.612 1.895 1.988 8.211-8.613z" }) });

// src/components/list.tsx
import { useCallback, useEffect, useRef } from "react";
import { clsx } from "clsx";

// src/constants.ts
var defaultThemeColor = "#ebd0c2";

// src/components/list.tsx
import { jsx as jsx4, jsxs } from "react/jsx-runtime";
function Playlist({
  open,
  audio,
  playingAudioUrl,
  onPlayAudio,
  listMaxHeight,
  themeColor = defaultThemeColor
}) {
  const olStyle = listMaxHeight ? { maxHeight: listMaxHeight } : void 0;
  const renderArtist = useCallback((artist) => {
    if (!artist)
      return "Audio artist";
    if (typeof artist === "string")
      return artist;
    return artist.name ?? "Audio artist";
  }, []);
  const listRef = useRef(null);
  useEffect(() => {
    if (listRef.current) {
      const listElement = listRef.current;
      listElement.style.maxHeight = `${Math.min(
        listElement.scrollHeight,
        listMaxHeight ?? Infinity
      )}px`;
      return () => {
        listElement.removeAttribute("style");
      };
    }
  }, [listMaxHeight]);
  return /* @__PURE__ */ jsx4(
    "div",
    {
      ref: listRef,
      className: clsx("aplayer-list", {
        "aplayer-list-hide": !open
      }),
      children: /* @__PURE__ */ jsx4("ol", { style: olStyle, children: audio.map((audioInfo, index) => /* @__PURE__ */ jsxs(
        "li",
        {
          className: clsx({
            "aplayer-list-light": audioInfo.url === playingAudioUrl
          }),
          onClick: () => {
            if (audioInfo.url !== playingAudioUrl) {
              onPlayAudio?.(audioInfo);
            }
          },
          children: [
            /* @__PURE__ */ jsx4(
              "span",
              {
                className: "aplayer-list-cur",
                style: {
                  backgroundColor: themeColor
                }
              }
            ),
            /* @__PURE__ */ jsx4("span", { className: "aplayer-list-index", children: index + 1 }),
            /* @__PURE__ */ jsx4("span", { className: "aplayer-list-title", children: audioInfo.name ?? "Audio name" }),
            /* @__PURE__ */ jsx4("span", { className: "aplayer-list-author", children: renderArtist(audioInfo.artist) })
          ]
        },
        index
      )) })
    }
  );
}

// src/components/controller.tsx
import { useCallback as useCallback4 } from "react";
import { clsx as clsx3 } from "clsx";

// src/assets/menu.svg
import * as React4 from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
var SvgMenu = (props) => /* @__PURE__ */ jsx5("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 32", ...props, children: /* @__PURE__ */ jsx5("path", { d: "M20.8 14.4q0.704 0 1.152 0.48t0.448 1.12-0.48 1.12-1.12 0.48h-19.2q-0.64 0-1.12-0.48t-0.48-1.12 0.448-1.12 1.152-0.48h19.2zM1.6 11.2q-0.64 0-1.12-0.48t-0.48-1.12 0.448-1.12 1.152-0.48h19.2q0.704 0 1.152 0.48t0.448 1.12-0.48 1.12-1.12 0.48h-19.2zM20.8 20.8q0.704 0 1.152 0.48t0.448 1.12-0.48 1.12-1.12 0.48h-19.2q-0.64 0-1.12-0.48t-0.48-1.12 0.448-1.12 1.152-0.48h19.2z" }) });

// src/assets/skip.svg
import * as React5 from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var SvgSkip = (props) => /* @__PURE__ */ jsx6("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props, children: /* @__PURE__ */ jsx6("path", { d: "M25.468 6.947c-0.326-0.172-0.724-0.151-1.030 0.057l-6.438 4.38v-3.553c0-0.371-0.205-0.71-0.532-0.884-0.326-0.172-0.724-0.151-1.030 0.057l-12 8.164c-0.274 0.186-0.438 0.496-0.438 0.827s0.164 0.641 0.438 0.827l12 8.168c0.169 0.115 0.365 0.174 0.562 0.174 0.16 0 0.321-0.038 0.468-0.116 0.327-0.173 0.532-0.514 0.532-0.884v-3.556l6.438 4.382c0.169 0.115 0.365 0.174 0.562 0.174 0.16 0 0.321-0.038 0.468-0.116 0.327-0.173 0.532-0.514 0.532-0.884v-16.333c0-0.371-0.205-0.71-0.532-0.884z" }) });

// src/assets/lrc.svg
import * as React6 from "react";
import { jsx as jsx7 } from "react/jsx-runtime";
var SvgLrc = (props) => /* @__PURE__ */ jsx7("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props, children: /* @__PURE__ */ jsx7("path", { d: "M26.667 5.333h-21.333c-0 0-0.001 0-0.001 0-1.472 0-2.666 1.194-2.666 2.666 0 0 0 0.001 0 0.001v-0 16c0 0 0 0.001 0 0.001 0 1.472 1.194 2.666 2.666 2.666 0 0 0.001 0 0.001 0h21.333c0 0 0.001 0 0.001 0 1.472 0 2.666-1.194 2.666-2.666 0-0 0-0.001 0-0.001v0-16c0-0 0-0.001 0-0.001 0-1.472-1.194-2.666-2.666-2.666-0 0-0.001 0-0.001 0h0zM5.333 16h5.333v2.667h-5.333v-2.667zM18.667 24h-13.333v-2.667h13.333v2.667zM26.667 24h-5.333v-2.667h5.333v2.667zM26.667 18.667h-13.333v-2.667h13.333v2.667z" }) });

// src/assets/order-list.svg
import * as React7 from "react";
import { jsx as jsx8 } from "react/jsx-runtime";
var SvgOrderList = (props) => /* @__PURE__ */ jsx8("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props, children: /* @__PURE__ */ jsx8("path", { d: "M0.622 18.334h19.54v7.55l11.052-9.412-11.052-9.413v7.549h-19.54v3.725z" }) });

// src/assets/order-random.svg
import * as React8 from "react";
import { jsx as jsx9 } from "react/jsx-runtime";
var SvgOrderRandom = (props) => /* @__PURE__ */ jsx9("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props, children: /* @__PURE__ */ jsx9("path", { d: "M22.667 4l7 6-7 6 7 6-7 6v-4h-3.653l-3.76-3.76 2.827-2.827 2.587 2.587h2v-8h-2l-12 12h-6v-4h4.347l12-12h3.653v-4zM2.667 8h6l3.76 3.76-2.827 2.827-2.587-2.587h-4.347v-4z" }) });

// src/assets/loop-all.svg
import * as React9 from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var SvgLoopAll = (props) => /* @__PURE__ */ jsx10("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 29 32", ...props, children: /* @__PURE__ */ jsx10("path", { d: "M9.333 9.333h13.333v4l5.333-5.333-5.333-5.333v4h-16v8h2.667v-5.333zM22.667 22.667h-13.333v-4l-5.333 5.333 5.333 5.333v-4h16v-8h-2.667v5.333z" }) });

// src/assets/loop-one.svg
import * as React10 from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
var SvgLoopOne = (props) => /* @__PURE__ */ jsx11("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 33 32", ...props, children: /* @__PURE__ */ jsx11("path", { d: "M9.333 9.333h13.333v4l5.333-5.333-5.333-5.333v4h-16v8h2.667v-5.333zM22.667 22.667h-13.333v-4l-5.333 5.333 5.333 5.333v-4h16v-8h-2.667v5.333zM17.333 20v-8h-1.333l-2.667 1.333v1.333h2v5.333h2z" }) });

// src/assets/loop-none.svg
import * as React11 from "react";
import { jsx as jsx12 } from "react/jsx-runtime";
var SvgLoopNone = (props) => /* @__PURE__ */ jsx12("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 29 32", ...props, children: /* @__PURE__ */ jsx12("path", { d: "M2.667 7.027l1.707-1.693 22.293 22.293-1.693 1.707-4-4h-11.64v4l-5.333-5.333 5.333-5.333v4h8.973l-8.973-8.973v0.973h-2.667v-3.64l-4-4zM22.667 17.333h2.667v5.573l-2.667-2.667v-2.907zM22.667 6.667v-4l5.333 5.333-5.333 5.333v-4h-10.907l-2.667-2.667h13.573z" }) });

// src/utils/formatAudioDuration.ts
function formatAudioDuration(seconds) {
  if (typeof seconds === "undefined") {
    return "--:--";
  }
  if (isNaN(seconds)) {
    return "00:00";
  }
  const pad0 = (num) => {
    return num < 10 ? "0" + num : "" + num;
  };
  const min = Math.trunc(seconds / 60);
  const sec = Math.trunc(seconds - min * 60);
  const hours = Math.trunc(min / 60);
  const minAdjust = Math.trunc(
    seconds / 60 - 60 * Math.trunc(seconds / 60 / 60)
  );
  return seconds >= 3600 ? pad0(hours) + ":" + pad0(minAdjust) + ":" + pad0(sec) : pad0(min) + ":" + pad0(sec);
}

// src/components/progress.tsx
import { useCallback as useCallback2, useEffect as useEffect2, useRef as useRef2, useState } from "react";

// src/assets/loading.svg
import * as React12 from "react";
import { jsx as jsx13 } from "react/jsx-runtime";
var SvgLoading = (props) => /* @__PURE__ */ jsx13("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props, children: /* @__PURE__ */ jsx13("path", { d: "M4 16c0-6.6 5.4-12 12-12s12 5.4 12 12c0 1.2-0.8 2-2 2s-2-0.8-2-2c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8c1.2 0 2 0.8 2 2s-0.8 2-2 2c-6.6 0-12-5.4-12-12z" }) });

// src/utils/computePercentage.ts
function computePercentage(eventTarget, progressBarRef) {
  if (!progressBarRef.current)
    return 0;
  let percentage = (eventTarget.clientX - progressBarRef.current.getBoundingClientRect().left) / progressBarRef.current.clientWidth;
  percentage = Math.max(percentage, 0);
  percentage = Math.min(percentage, 1);
  percentage = Math.floor(percentage * 100) / 100;
  return percentage;
}
function computePercentageOfY(eventTarget, volumeBarRef) {
  if (!volumeBarRef.current)
    return 0;
  let percentage = 1 - (eventTarget.clientY - volumeBarRef.current.getBoundingClientRect().top) / volumeBarRef.current.clientHeight;
  percentage = Math.max(percentage, 0);
  percentage = Math.min(percentage, 1);
  percentage = Math.floor(percentage * 100) / 100;
  return percentage;
}

// src/components/progress.tsx
import { jsx as jsx14, jsxs as jsxs2 } from "react/jsx-runtime";
function ProgressBar({
  themeColor,
  bufferedPercentage,
  playedPercentage,
  onSeek
}) {
  const progressBarRef = useRef2(null);
  const [progress, setProgress] = useState(playedPercentage);
  const isDraggingRef = useRef2(false);
  useEffect2(() => {
    if (!isDraggingRef.current) {
      setProgress(playedPercentage);
    }
  }, [playedPercentage]);
  const handleMouseDown = useCallback2(
    (e) => {
      isDraggingRef.current = true;
      const percentage = computePercentage(e, progressBarRef);
      setProgress(percentage);
      const handleMouseMove = (e2) => {
        const percentage2 = computePercentage(e2, progressBarRef);
        setProgress(percentage2);
      };
      const handleMouseUp = (e2) => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        const percentage2 = computePercentage(e2, progressBarRef);
        setProgress(percentage2);
        onSeek?.(percentage2);
        isDraggingRef.current = false;
      };
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    },
    [onSeek]
  );
  return /* @__PURE__ */ jsx14(
    "div",
    {
      ref: progressBarRef,
      className: "aplayer-bar-wrap",
      onMouseDown: handleMouseDown,
      children: /* @__PURE__ */ jsxs2("div", { className: "aplayer-bar", children: [
        typeof bufferedPercentage !== "undefined" ? /* @__PURE__ */ jsx14(
          "div",
          {
            className: "aplayer-loaded",
            style: { width: `${bufferedPercentage * 100}%` }
          }
        ) : null,
        typeof progress !== "undefined" ? /* @__PURE__ */ jsx14(
          "div",
          {
            className: "aplayer-played",
            style: {
              width: `${progress * 100}%`,
              backgroundColor: themeColor
            },
            children: /* @__PURE__ */ jsx14(
              "span",
              {
                className: "aplayer-thumb",
                style: { backgroundColor: themeColor },
                children: /* @__PURE__ */ jsx14("span", { className: "aplayer-loading-icon", children: /* @__PURE__ */ jsx14(SvgLoading, {}) })
              }
            )
          }
        ) : null
      ] })
    }
  );
}

// src/components/volume.tsx
import { useCallback as useCallback3, useRef as useRef3, useState as useState2 } from "react";

// src/assets/volume-up.svg
import * as React14 from "react";
import { jsx as jsx15 } from "react/jsx-runtime";
var SvgVolumeUp = (props) => /* @__PURE__ */ jsx15("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 32", ...props, children: /* @__PURE__ */ jsx15("path", { d: "M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528zM25.152 16q0 2.72-1.536 5.056t-4 3.36q-0.256 0.096-0.448 0.096-0.48 0-0.832-0.352t-0.32-0.8q0-0.704 0.672-1.056 1.024-0.512 1.376-0.8 1.312-0.96 2.048-2.4t0.736-3.104-0.736-3.104-2.048-2.4q-0.352-0.288-1.376-0.8-0.672-0.352-0.672-1.056 0-0.448 0.32-0.8t0.8-0.352q0.224 0 0.48 0.096 2.496 1.056 4 3.36t1.536 5.056zM29.728 16q0 4.096-2.272 7.552t-6.048 5.056q-0.224 0.096-0.448 0.096-0.48 0-0.832-0.352t-0.32-0.8q0-0.64 0.704-1.056 0.128-0.064 0.384-0.192t0.416-0.192q0.8-0.448 1.44-0.896 2.208-1.632 3.456-4.064t1.216-5.152-1.216-5.152-3.456-4.064q-0.64-0.448-1.44-0.896-0.128-0.096-0.416-0.192t-0.384-0.192q-0.704-0.416-0.704-1.056 0-0.448 0.32-0.8t0.832-0.352q0.224 0 0.448 0.096 3.776 1.632 6.048 5.056t2.272 7.552z" }) });

// src/assets/volume-down.svg
import * as React15 from "react";
import { jsx as jsx16 } from "react/jsx-runtime";
var SvgVolumeDown = (props) => /* @__PURE__ */ jsx16("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 32", ...props, children: /* @__PURE__ */ jsx16("path", { d: "M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528z" }) });

// src/assets/volume-off.svg
import * as React16 from "react";
import { jsx as jsx17 } from "react/jsx-runtime";
var SvgVolumeOff = (props) => /* @__PURE__ */ jsx17("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 32", ...props, children: /* @__PURE__ */ jsx17("path", { d: "M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8z" }) });

// src/components/volume.tsx
import clsx2 from "clsx";
import { jsx as jsx18, jsxs as jsxs3 } from "react/jsx-runtime";
function Volume({
  themeColor,
  volume,
  muted,
  onToggleMuted,
  onChangeVolume
}) {
  const volumeBarRef = useRef3(null);
  const [isDragging, setDragging] = useState2(false);
  const handleMouseDown = useCallback3(
    (e) => {
      onChangeVolume(computePercentageOfY(e, volumeBarRef));
      setDragging(true);
      const handleMouseMove = (e2) => {
        onChangeVolume(computePercentageOfY(e2, volumeBarRef));
      };
      const handleMouseUp = (e2) => {
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("mousemove", handleMouseMove);
        setDragging(false);
        onChangeVolume(computePercentageOfY(e2, volumeBarRef));
      };
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    },
    [onChangeVolume]
  );
  return /* @__PURE__ */ jsxs3("div", { className: "aplayer-volume-wrap", children: [
    /* @__PURE__ */ jsx18(
      "button",
      {
        className: "aplayer-icon aplayer-icon-volume-down",
        onClick: () => onToggleMuted(),
        children: muted || !volume ? /* @__PURE__ */ jsx18(SvgVolumeOff, {}) : volume >= 1 ? /* @__PURE__ */ jsx18(SvgVolumeUp, {}) : /* @__PURE__ */ jsx18(SvgVolumeDown, {})
      }
    ),
    /* @__PURE__ */ jsx18(
      "div",
      {
        className: clsx2("aplayer-volume-bar-wrap", {
          "aplayer-volume-bar-wrap-active": isDragging
        }),
        ref: volumeBarRef,
        onMouseDown: handleMouseDown,
        children: /* @__PURE__ */ jsx18("div", { className: "aplayer-volume-bar", children: /* @__PURE__ */ jsx18(
          "div",
          {
            className: "aplayer-volume",
            style: {
              backgroundColor: themeColor,
              height: muted ? 0 : `${volume * 100}%`
            }
          }
        ) })
      }
    )
  ] });
}

// src/components/controller.tsx
import { jsx as jsx19, jsxs as jsxs4 } from "react/jsx-runtime";
function PlaybackControls({
  themeColor,
  volume,
  onChangeVolume,
  muted,
  currentTime,
  audioDurationSeconds,
  bufferedSeconds,
  onToggleMenu,
  onToggleMuted,
  order,
  onOrderChange,
  loop,
  onLoopChange,
  onSeek,
  isPlaying,
  onTogglePlay,
  onSkipForward,
  onSkipBack,
  showLyrics = true,
  onToggleLyrics
}) {
  const handleOrderButtonClick = useCallback4(() => {
    const nextOrder = {
      list: "random",
      random: "list"
    }[order];
    onOrderChange(nextOrder);
  }, [order, onOrderChange]);
  const handleLoopButtonClick = useCallback4(() => {
    const nextLoop = {
      all: "one",
      one: "none",
      none: "all"
    }[loop];
    onLoopChange(nextLoop);
  }, [loop, onLoopChange]);
  return /* @__PURE__ */ jsxs4("div", { className: "aplayer-controller", children: [
    /* @__PURE__ */ jsx19(
      ProgressBar,
      {
        themeColor,
        playedPercentage: typeof currentTime === "undefined" || typeof audioDurationSeconds === "undefined" ? void 0 : currentTime / audioDurationSeconds,
        bufferedPercentage: typeof bufferedSeconds === "undefined" || typeof audioDurationSeconds === "undefined" ? void 0 : bufferedSeconds / audioDurationSeconds,
        onSeek: (progress) => onSeek?.(progress * audioDurationSeconds)
      }
    ),
    /* @__PURE__ */ jsxs4("div", { className: "aplayer-time", children: [
      /* @__PURE__ */ jsxs4("span", { className: "aplayer-time-inner", children: [
        /* @__PURE__ */ jsx19("span", { className: "aplayer-ptime", children: formatAudioDuration(currentTime) }),
        " / ",
        /* @__PURE__ */ jsx19("span", { className: "aplayer-dtime", children: formatAudioDuration(audioDurationSeconds) })
      ] }),
      /* @__PURE__ */ jsx19("span", { className: "aplayer-icon aplayer-icon-back", onClick: onSkipBack, children: /* @__PURE__ */ jsx19(SvgSkip, {}) }),
      /* @__PURE__ */ jsx19("span", { className: "aplayer-icon aplayer-icon-play", onClick: onTogglePlay, children: isPlaying ? /* @__PURE__ */ jsx19(SvgPause, {}) : /* @__PURE__ */ jsx19(SvgPlay, {}) }),
      /* @__PURE__ */ jsx19(
        "span",
        {
          className: "aplayer-icon aplayer-icon-forward",
          onClick: onSkipForward,
          children: /* @__PURE__ */ jsx19(SvgSkip, {})
        }
      ),
      /* @__PURE__ */ jsx19(
        Volume,
        {
          themeColor,
          volume,
          muted,
          onToggleMuted,
          onChangeVolume
        }
      ),
      /* @__PURE__ */ jsx19(
        "button",
        {
          className: "aplayer-icon aplayer-icon-order",
          onClick: handleOrderButtonClick,
          children: { list: /* @__PURE__ */ jsx19(SvgOrderList, {}), random: /* @__PURE__ */ jsx19(SvgOrderRandom, {}) }[order]
        }
      ),
      /* @__PURE__ */ jsx19(
        "button",
        {
          className: "aplayer-icon aplayer-icon-loop",
          onClick: handleLoopButtonClick,
          children: {
            all: /* @__PURE__ */ jsx19(SvgLoopAll, {}),
            one: /* @__PURE__ */ jsx19(SvgLoopOne, {}),
            none: /* @__PURE__ */ jsx19(SvgLoopNone, {})
          }[loop]
        }
      ),
      /* @__PURE__ */ jsx19(
        "button",
        {
          className: "aplayer-icon aplayer-icon-menu",
          onClick: () => onToggleMenu?.(),
          children: /* @__PURE__ */ jsx19(SvgMenu, {})
        }
      ),
      /* @__PURE__ */ jsx19(
        "button",
        {
          type: "button",
          className: clsx3("aplayer-icon aplayer-icon-lrc", {
            "aplayer-icon-lrc-inactivity": !showLyrics
          }),
          onClick: onToggleLyrics,
          children: /* @__PURE__ */ jsx19(SvgLrc, {})
        }
      )
    ] })
  ] });
}

// src/hooks/useAudioControl.ts
import { useCallback as useCallback5, useEffect as useEffect3, useRef as useRef4 } from "react";
import { useSyncExternalStore } from "use-sync-external-store/shim/index.js";
function useCreateAudioElement(options) {
  const audioElementRef = useRef4();
  if (typeof document !== "undefined" && !audioElementRef.current) {
    const audio = audioElementRef.current = document.createElement("audio");
    if (typeof options?.src !== "undefined") {
      audio.src = options.src;
    }
    if (typeof options?.autoPlay !== "undefined") {
      audio.autoplay = options.autoPlay;
    }
    if (typeof options?.initialVolume !== "undefined") {
      audio.volume = options.initialVolume;
    }
  }
  useEffect3(() => {
    const audio = audioElementRef.current;
    if (audio && options?.onError) {
      audio.addEventListener("error", options.onError);
      return () => {
        audio.removeEventListener("error", options.onError);
      };
    }
  }, [options?.onError]);
  useEffect3(() => {
    const audio = audioElementRef.current;
    if (audio && options?.onEnded) {
      audio.addEventListener("ended", options.onEnded);
      return () => {
        audio.removeEventListener("ended", options.onEnded);
      };
    }
  }, [options?.onEnded]);
  useEffect3(() => {
    return () => {
      const audio = audioElementRef.current;
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
      audioElementRef.current = void 0;
    };
  }, []);
  return audioElementRef;
}
function useAudioControl(options) {
  const audioElementRef = useCreateAudioElement(options);
  const playAudio = useCallback5(
    async (src) => {
      const audio = audioElementRef.current;
      if (audio) {
        if (audio.src !== src) {
          audio.pause();
          audio.currentTime = 0;
          audio.src = src;
        }
        try {
          await audioElementRef.current?.play();
        } catch {
        }
      }
    },
    [audioElementRef]
  );
  const togglePlay = useCallback5(
    (src) => {
      const audio = audioElementRef.current;
      if (!audio) {
        return;
      }
      if (audio.paused) {
        playAudio(src);
      } else {
        audio.pause();
      }
    },
    [audioElementRef, playAudio]
  );
  const seek = useCallback5(
    (second) => {
      audioElementRef.current.currentTime = second;
    },
    [audioElementRef]
  );
  const toggleMuted = useCallback5(() => {
    if (audioElementRef.current) {
      audioElementRef.current.muted = !audioElementRef.current.muted;
    }
  }, [audioElementRef]);
  const setVolume = useCallback5(
    (value) => {
      if (audioElementRef.current) {
        audioElementRef.current.volume = value;
      }
    },
    [audioElementRef]
  );
  const volume = useSyncExternalStore(
    useCallback5(
      (onStoreChange) => {
        audioElementRef.current?.addEventListener(
          "volumechange",
          onStoreChange
        );
        return () => {
          audioElementRef.current?.removeEventListener(
            "volumechange",
            onStoreChange
          );
        };
      },
      [audioElementRef]
    ),
    () => audioElementRef.current?.volume,
    () => void 0
  );
  const muted = useSyncExternalStore(
    useCallback5(
      (onStoreChange) => {
        audioElementRef.current?.addEventListener(
          "volumechange",
          onStoreChange
        );
        return () => {
          audioElementRef.current?.removeEventListener(
            "volumechange",
            onStoreChange
          );
        };
      },
      [audioElementRef]
    ),
    () => audioElementRef.current?.muted,
    () => void 0
  );
  const currentTime = useSyncExternalStore(
    useCallback5(
      (onStoreChange) => {
        audioElementRef.current?.addEventListener("timeupdate", onStoreChange);
        return () => {
          audioElementRef.current?.removeEventListener(
            "timeupdate",
            onStoreChange
          );
        };
      },
      [audioElementRef]
    ),
    () => {
      if (!audioElementRef.current) {
        return void 0;
      }
      return Math.round(audioElementRef.current.currentTime);
    },
    () => void 0
  );
  const duration = useSyncExternalStore(
    useCallback5(
      (onStoreChange) => {
        audioElementRef.current?.addEventListener(
          "durationchange",
          onStoreChange
        );
        return () => {
          audioElementRef.current?.removeEventListener(
            "durationchange",
            onStoreChange
          );
        };
      },
      [audioElementRef]
    ),
    () => audioElementRef.current?.duration,
    () => void 0
  );
  const bufferedSeconds = useSyncExternalStore(
    useCallback5(
      (onStoreChange) => {
        audioElementRef.current?.addEventListener("progress", onStoreChange);
        return () => {
          audioElementRef.current?.removeEventListener(
            "progress",
            onStoreChange
          );
        };
      },
      [audioElementRef]
    ),
    () => {
      const audio = audioElementRef.current;
      if (!audio)
        return 0;
      if (audio.buffered.length > 0) {
        return audio.buffered.end(audio.buffered.length - 1);
      }
      return 0;
    },
    () => void 0
  );
  const isPlaying = useSyncExternalStore(
    useCallback5(
      (onStoreChange) => {
        audioElementRef.current?.addEventListener("play", onStoreChange);
        audioElementRef.current?.addEventListener("pause", onStoreChange);
        return () => {
          audioElementRef.current?.removeEventListener("play", onStoreChange);
          audioElementRef.current?.removeEventListener("pause", onStoreChange);
        };
      },
      [audioElementRef]
    ),
    () => {
      const audio = audioElementRef.current;
      return audio ? !audio.paused : false;
    },
    () => void 0
  );
  const isLoading = useSyncExternalStore(
    useCallback5(
      (onStoreChange) => {
        audioElementRef.current?.addEventListener("playing", onStoreChange);
        audioElementRef.current?.addEventListener("waiting", onStoreChange);
        return () => {
          audioElementRef.current?.removeEventListener(
            "playing",
            onStoreChange
          );
          audioElementRef.current?.removeEventListener(
            "waiting",
            onStoreChange
          );
        };
      },
      [audioElementRef]
    ),
    () => {
      const audio = audioElementRef.current;
      if (!audio)
        return false;
      return audio.networkState === audio.NETWORK_LOADING;
    },
    () => void 0
  );
  return {
    volume,
    setVolume,
    muted,
    toggleMuted,
    isPlaying,
    duration,
    currentTime,
    bufferedSeconds,
    playAudio,
    togglePlay,
    seek,
    isLoading
  };
}

// src/hooks/usePlaylist.ts
import { useCallback as useCallback6, useEffect as useEffect4, useMemo, useState as useState3 } from "react";

// src/utils/shuffle.ts
function shuffle(array) {
  return shuffleInPlace(array.slice());
}
function shuffleInPlace(array) {
  let currentIndex = array.length, randomIndex;
  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex]
    ];
  }
  return array;
}

// src/hooks/usePlaylist.ts
function usePlaylist(songs, {
  initialLoop = "all",
  initialOrder = "list",
  getSongId
}) {
  const [loop, setLoop] = useState3(initialLoop);
  const [order, setOrder] = useState3(initialOrder);
  const list = useMemo(() => {
    if (order === "list") {
      return songs;
    }
    return shuffle(songs);
  }, [songs, order]);
  const [currentSong, setCurrentSong] = useState3(list[0]);
  useEffect4(() => {
    const sameSong = list.find(
      (song) => getSongId(song) === getSongId(currentSong)
    );
    if (sameSong) {
      setCurrentSong(sameSong);
    } else {
      setCurrentSong(list[0]);
    }
  }, [list, getSongId, currentSong]);
  const nextSong = useMemo(() => {
    const currentSongIndex = list.indexOf(currentSong);
    if (currentSongIndex < list.length - 1) {
      return list[currentSongIndex + 1];
    }
    if (loop !== "none")
      return list[0];
    return void 0;
  }, [list, currentSong, loop]);
  const next = useCallback6(() => {
    if (nextSong) {
      setCurrentSong(nextSong);
    }
  }, [nextSong]);
  const previous = useCallback6(() => {
    setCurrentSong((prev) => {
      const currentSongIndex = list.indexOf(prev);
      if (currentSongIndex > 0) {
        return list[currentSongIndex - 1];
      }
      return prev;
    });
  }, [list]);
  const prioritize = useCallback6((song) => {
    setCurrentSong(song);
  }, []);
  return {
    currentSong,
    hasNextSong: typeof nextSong !== "undefined",
    next,
    previous,
    prioritize,
    order,
    setOrder,
    loop,
    setLoop,
    length: list.length
  };
}

// src/components/lyrics.tsx
import { useMemo as useMemo2 } from "react";
import { clsx as clsx4 } from "clsx";
import { jsx as jsx20 } from "react/jsx-runtime";
function Lyrics({ show, lrcText, currentTime }) {
  const lines = useMemo2(() => parseLrc(lrcText), [lrcText]);
  const currentLineIndex = useMemo2(() => {
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      const nextLine = lines[i + 1];
      if (currentTime >= line[0] && (!nextLine || currentTime < nextLine[0])) {
        return i;
      }
    }
    return 0;
  }, [currentTime, lines]);
  const transformStyle = useMemo2(() => {
    return {
      transform: `translateY(${-currentLineIndex * 16}px)`,
      WebkitTransform: `translateY(${-currentLineIndex * 16}px)`
    };
  }, [currentLineIndex]);
  return /* @__PURE__ */ jsx20(
    "div",
    {
      className: clsx4("aplayer-lrc", {
        "aplayer-lrc-hide": !show
      }),
      children: lrcText ? /* @__PURE__ */ jsx20("div", { className: "aplayer-lrc-contents", style: transformStyle, children: lines.map(([, text], index) => /* @__PURE__ */ jsx20(
        "p",
        {
          className: clsx4({
            "aplayer-lrc-current": index === currentLineIndex
          }),
          children: text
        },
        index
      )) }) : null
    }
  );
}
function parseLrc(lrc_s) {
  if (lrc_s) {
    lrc_s = lrc_s.replace(/([^\]^\n])\[/g, (match, p1) => p1 + "\n[");
    const lyric = lrc_s.split("\n");
    const lrc = [];
    const lyricLen = lyric.length;
    for (let i = 0; i < lyricLen; i++) {
      const lrcTimes = lyric[i].match(/\[(\d{2}):(\d{2})(\.(\d{2,3}))?]/g);
      const lrcText = lyric[i].replace(/.*\[(\d{2}):(\d{2})(\.(\d{2,3}))?]/g, "").replace(/<(\d{2}):(\d{2})(\.(\d{2,3}))?>/g, "").replace(/^\s+|\s+$/g, "");
      if (lrcTimes) {
        const timeLen = lrcTimes.length;
        for (let j = 0; j < timeLen; j++) {
          const oneTime = /\[(\d{2}):(\d{2})(\.(\d{2,3}))?]/.exec(lrcTimes[j]);
          const min2sec = oneTime[1] * 60;
          const sec2sec = parseInt(oneTime[2]);
          const msec2sec = oneTime[4] ? parseInt(oneTime[4]) / ((oneTime[4] + "").length === 2 ? 100 : 1e3) : 0;
          const lrcTime = min2sec + sec2sec + msec2sec;
          lrc.push([lrcTime, lrcText]);
        }
      }
    }
    lrc.sort((a, b) => a[0] - b[0]);
    return lrc;
  } else {
    return [];
  }
}

// src/hooks/useThemeColor.ts
import { useEffect as useEffect5, useState as useState4 } from "react";

// src/utils/getImageColor.ts
import { FastAverageColor } from "fast-average-color";
var facSingleton;
function getImageColor(imageUrl) {
  const fac = facSingleton ?? (facSingleton = new FastAverageColor());
  return fac.getColorAsync(imageUrl, {
    ignoredColor: [255, 255, 255, 255]
  }).then((color) => {
    return color.hex;
  });
}

// src/hooks/useThemeColor.ts
function shouldUseColorThief(song, fallback = defaultThemeColor) {
  if (song?.theme === "auto" && song.cover)
    return true;
  return fallback === "auto" && Boolean(song?.cover);
}
function useThemeColor(song, fallback = defaultThemeColor) {
  const [coverColorMap, setCoverColorMap] = useState4(
    {}
  );
  useEffect5(() => {
    if (shouldUseColorThief(song, fallback)) {
      const coverUrl = song.cover;
      getImageColor(coverUrl).then((hex) => {
        setCoverColorMap((prev) => ({
          ...prev,
          [coverUrl]: hex
        }));
      });
    }
  }, [song, fallback]);
  if (!song) {
    return fallback;
  }
  if (shouldUseColorThief(song, fallback)) {
    return coverColorMap[song.cover] ?? (fallback === "auto" ? defaultThemeColor : fallback);
  }
  return song.theme ?? (fallback === "auto" ? defaultThemeColor : fallback);
}

// src/hooks/useNotice.ts
import { useCallback as useCallback8, useRef as useRef6, useState as useState5 } from "react";

// src/hooks/useSetTimeout.ts
import { useCallback as useCallback7, useEffect as useEffect6, useRef as useRef5 } from "react";
function useSetTimeout() {
  const timeoutsRef = useRef5([]);
  useEffect6(() => {
    const timeouts = timeoutsRef.current;
    return () => {
      for (const timeout of timeouts) {
        clearTimeout(timeout);
      }
    };
  }, []);
  const safeSetTimeout = useCallback7((callback, ms) => {
    const timeout = setTimeout(callback, ms);
    timeoutsRef.current.push(timeout);
    return timeout;
  }, []);
  return safeSetTimeout;
}

// src/hooks/useNotice.ts
function useNotice() {
  const timerRef = useRef6();
  const [notice, setNotice] = useState5({ text: "", style: { opacity: 0 } });
  const setTimeout2 = useSetTimeout();
  const showNotice = useCallback8(
    (text, duration = 2e3) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      setNotice({ text, style: { opacity: 1 } });
      timerRef.current = setTimeout2(() => {
        setNotice({ text, style: { opacity: 0 } });
      }, duration);
    },
    [setTimeout2]
  );
  return [notice, showNotice];
}

// src/components/player.tsx
import { jsx as jsx21, jsxs as jsxs5 } from "react/jsx-runtime";
function APlayer({
  theme = defaultThemeColor,
  audio,
  appearance = "normal",
  volume = 0.7,
  initialLoop,
  initialOrder,
  autoPlay = false,
  listMaxHeight = 250
}) {
  const playlist = usePlaylist(Array.isArray(audio) ? audio : [audio], {
    initialLoop,
    initialOrder,
    getSongId: (song) => song.url
  });
  const [notice, showNotice] = useNotice();
  const autoSkipTimeoutRef = useRef7();
  const setTimeout2 = useSetTimeout();
  const cancelAutoSkip = useCallback9(() => {
    if (autoSkipTimeoutRef.current) {
      clearTimeout(autoSkipTimeoutRef.current);
      autoSkipTimeoutRef.current = void 0;
    }
  }, []);
  const audioControl = useAudioControl({
    src: playlist.currentSong.url,
    initialVolume: volume,
    autoPlay,
    onError(e) {
      const { error } = e.target;
      if (error) {
        showNotice(
          "An audio error has occurred, player will skip forward in 2 seconds."
        );
      }
      if (playlist.hasNextSong) {
        autoSkipTimeoutRef.current = setTimeout2(() => {
          playlist.next();
        }, 2e3);
      }
    },
    onEnded() {
      if (playlist.hasNextSong) {
        playlist.next();
      }
    }
  });
  useEffect7(() => {
    if (autoPlay) {
      audioControl.playAudio(playlist.currentSong.url);
    }
  }, []);
  const isInitialEffectRef = useRef7(true);
  useEffect7(() => {
    if (isInitialEffectRef.current) {
      isInitialEffectRef.current = false;
    } else {
      if (playlist.currentSong) {
        audioControl.playAudio(playlist.currentSong.url);
      }
    }
  }, [playlist.currentSong, audioControl.playAudio]);
  const handlePlayButtonClick = useCallback9(() => {
    cancelAutoSkip();
    audioControl.togglePlay(playlist.currentSong.url);
  }, [audioControl, cancelAutoSkip, playlist.currentSong.url]);
  const hasPlaylist = playlist.length > 1;
  const [isPlaylistOpen, setPlaylistOpen] = useState6(() => hasPlaylist);
  const themeColor = useThemeColor(playlist.currentSong, theme);
  const playlistAudioProp = useMemo3(
    () => Array.isArray(audio) ? audio : [audio],
    [audio]
  );
  const { prioritize } = playlist;
  const handlePlayAudioFromList = useCallback9(
    (audioInfo) => {
      cancelAutoSkip();
      prioritize(audioInfo);
    },
    [cancelAutoSkip, prioritize]
  );
  const renderArtist = useCallback9((artist) => {
    if (!artist)
      return "Audio artist";
    if (typeof artist === "string")
      return artist;
    if (!artist.url) {
      return artist.name ?? "Audio artist";
    }
    return /* @__PURE__ */ jsx21("a", { href: artist.url, target: "_blank", rel: "noreferrer", children: artist.name ?? "Audio artist" });
  }, []);
  const [mini, setMini] = useState6(false);
  const [displayLyrics, setDisplayLyrics] = useState6(true);
  const bodyRef = useRef7(null);
  useEffect7(() => {
    if (appearance === "fixed") {
      if (bodyRef.current) {
        const bodyElement = bodyRef.current;
        bodyElement.style.width = bodyElement.offsetWidth - 18 + "px";
        return () => {
          bodyElement.removeAttribute("style");
        };
      }
    }
  }, [appearance]);
  return /* @__PURE__ */ jsxs5(
    "div",
    {
      className: clsx5("aplayer", {
        "aplayer-fixed": appearance === "fixed",
        "aplayer-loading": audioControl.isLoading,
        "aplayer-withlist": hasPlaylist,
        "aplayer-withlrc": Boolean(playlist.currentSong.lrc) && appearance !== "fixed",
        "aplayer-narrow": mini
      }),
      children: [
        /* @__PURE__ */ jsxs5("div", { ref: bodyRef, className: "aplayer-body", children: [
          /* @__PURE__ */ jsx21(
            "div",
            {
              className: "aplayer-pic",
              onClick: handlePlayButtonClick,
              style: {
                backgroundImage: `url("${playlist.currentSong?.cover}")`
              },
              children: /* @__PURE__ */ jsx21(
                "div",
                {
                  className: clsx5(
                    "aplayer-button",
                    audioControl.isPlaying ? "aplayer-pause" : "aplayer-play"
                  ),
                  children: audioControl.isPlaying ? /* @__PURE__ */ jsx21(SvgPause, {}) : /* @__PURE__ */ jsx21(SvgPlay, {})
                }
              )
            }
          ),
          /* @__PURE__ */ jsxs5("div", { className: "aplayer-info", children: [
            /* @__PURE__ */ jsxs5("div", { className: "aplayer-music", children: [
              /* @__PURE__ */ jsx21("span", { className: "aplayer-title", children: playlist.currentSong?.name ?? "Audio name" }),
              /* @__PURE__ */ jsxs5("span", { className: "aplayer-author", children: [
                " ",
                "- ",
                renderArtist(playlist.currentSong?.artist)
              ] })
            ] }),
            appearance === "fixed" ? null : /* @__PURE__ */ jsx21(
              Lyrics,
              {
                show: displayLyrics,
                lrcText: playlist.currentSong.lrc,
                currentTime: audioControl.currentTime ?? 0
              }
            ),
            /* @__PURE__ */ jsx21(
              PlaybackControls,
              {
                volume: audioControl.volume ?? volume,
                onChangeVolume: audioControl.setVolume,
                muted: audioControl.muted ?? false,
                onToggleMuted: () => audioControl.toggleMuted(),
                themeColor,
                currentTime: audioControl.currentTime,
                audioDurationSeconds: audioControl.duration,
                bufferedSeconds: audioControl.bufferedSeconds,
                onSeek: (second) => audioControl.seek(second),
                onToggleMenu: () => setPlaylistOpen((open) => !open),
                order: playlist.order,
                onOrderChange: playlist.setOrder,
                loop: playlist.loop,
                onLoopChange: playlist.setLoop,
                isPlaying: audioControl.isPlaying ?? false,
                onTogglePlay: handlePlayButtonClick,
                onSkipForward: () => {
                  if (playlist.hasNextSong) {
                    playlist.next();
                  }
                },
                onSkipBack: () => {
                  playlist.previous();
                },
                showLyrics: displayLyrics,
                onToggleLyrics: () => {
                  setDisplayLyrics((prev) => !prev);
                }
              }
            )
          ] }),
          /* @__PURE__ */ jsx21("div", { className: "aplayer-notice", style: notice.style, children: notice.text }),
          /* @__PURE__ */ jsx21(
            "div",
            {
              className: "aplayer-miniswitcher",
              onClick: () => setMini((prev) => !prev),
              children: /* @__PURE__ */ jsx21("button", { className: "aplayer-icon", children: /* @__PURE__ */ jsx21(SvgRight, {}) })
            }
          )
        ] }),
        hasPlaylist ? /* @__PURE__ */ jsx21(
          Playlist,
          {
            themeColor,
            open: isPlaylistOpen,
            audio: playlistAudioProp,
            playingAudioUrl: playlist.currentSong.url,
            onPlayAudio: handlePlayAudioFromList,
            listMaxHeight
          }
        ) : null,
        appearance === "fixed" && /* @__PURE__ */ jsx21(
          Lyrics,
          {
            show: displayLyrics,
            lrcText: playlist.currentSong.lrc,
            currentTime: audioControl.currentTime ?? 0
          }
        )
      ]
    }
  );
}
export {
  APlayer
};
